// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.video-js {
  display: block;
  margin: 0 auto;
  width: 640px;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/components/videojs.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,cAAc;EACd,YAAY;AACd","sourcesContent":[".video-js {\n  display: block;\n  margin: 0 auto;\n  width: 640px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
